import $ from "jquery";
import Constants from "./Constants";
import GigyaManager from "./GigyaManager";

class RestManager {

    testConnection(){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUser().then((user) => {
                let obj = {
                    token: Constants.API_TOKEN
                }
                $.ajax(Constants.API_ENDPOINT + '/api/test-connection', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(obj),
                    beforeSend: (xhr) => {
                    }
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    }else{
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    userStatus(){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let obj = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                }
                $.ajax(Constants.API_ENDPOINT + '/api/status/user', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(obj),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    playReceipt(formJson){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let def = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                    user_first_name: user.profile.firstName,
                    user_last_name: user.profile.lastName,
                    user_email: user.profile.email
                }
                $.extend(def, formJson);
                $.ajax(Constants.API_ENDPOINT + '/api/play/receipt', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(def),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    uploadImage(type, file){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let formData = new FormData();
                formData.append("token", Constants.API_TOKEN);
                formData.append("idtoken", jwt.id_token);
                formData.append("type",type);
                formData.append("file", file);

                $.ajax(Constants.API_ENDPOINT + '/api/files/upload', {
                    type: "POST",
                    contentType: false,
                    processData: false,
                    data: formData
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    prizeRequest(form){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let def = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                }
                $.extend(def, form);
                $.ajax(Constants.API_ENDPOINT + '/api/update/user', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(def),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }

    associateTelephone(telephone){
        return new Promise((resolve, reject) => {
            GigyaManager.getLoggedUserCached().then(async (user) => {
                let jwt = await GigyaManager.getJWT();
                let def = {
                    token: Constants.API_TOKEN,
                    user_gigya_token: user.UID,
                    idtoken: jwt.id_token,
                    user_phone_number: telephone,
                    user_first_name: user.profile.firstName,
                    user_last_name: user.profile.lastName,
                    user_email: user.profile.email
                }
                $.ajax(Constants.API_ENDPOINT + '/api/merge/user', {
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(def),
                }).done((resp) => {
                    if(resp.status.runtime.data){
                        resolve(resp);
                    } else {
                        reject(resp);
                    }

                }).fail((resp) => {
                    reject(resp);
                });
            });
        });
    }




}

export default new RestManager();
